// 1. 引入你需要的组件
import { Button, Switch, Field } from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';

// 3. 注册你需要的组件
const vantInstall = (app) => {
    app.use(Button).use(Switch).use(Field);
}
export default vantInstall